import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// LL87 flow redesign Stage D — frame 17's PM planner (cohort view over
// the PR-C staff cohorts API). Route mounted; nav-link placement is
// Leo's call. Access rides the server-side `IsTrackingEnabled` gate
// (staff or the `tracking_beta` group, 404-not-403) — the page renders
// the honest not-available panel on 404.
export const Route = createFileRoute("/portal/ll87-planner")({
  component: lazyRouteComponent(() => import("@/pages/Portal/Ll87Planner/Page")),
});
